import graphqlClient from '~/graphql/graphqlClient';

export type StartInnBattleResult = {
  battle_id: string;
};

export type MutationStartInnBattleArgs = {
  playerId: string;
  battleId: string;
};

const mutation = `
mutation StartInnBattle($playerId: String!, $battleId: String!) {
  startInnBattle(playerId: $playerId, battleId: $battleId) {
    battle_id
  }
}
`;

export default async function mutationStartInnBattle(
  args: MutationStartInnBattleArgs
): Promise<StartInnBattleResult> {
  return await graphqlClient.request<StartInnBattleResult>(
    'startInnBattle',
    mutation,
    args
  );
}
